<script lang="ts">
export default {
  name: 'UIDialog',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { DialogRoot } from 'reka-ui';

interface Props {
  open?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  'update:open': [value: boolean];
}>();

const isOpen = computed({
  get: () => props.open ?? false,
  set: (value) => emit('update:open', value),
});
</script>

<template>
  <DialogRoot v-model:open="isOpen">
    <slot />
  </DialogRoot>
</template>
